<template>
<div id="social-links-page">
  <v-container fluid grid-list-xl>
    <v-layout row wrap justify-center>
      <v-flex xs12 offset-md3 offset-lg2>
        <span class="display-1">Social Links</span> <v-btn v-if="!showAboutForm" style="margin-bottom: 18px;" class="primary" @click="showAddForm" round icon><v-icon>add</v-icon></v-btn>
      </v-flex>
      <v-flex v-if="aboutData.length > 0 && !showAboutForm" xs12 md9 offset-md3 offset-lg1>
        <!-- <v-card v-for="(item, index) in aboutData" :key="index" color="grey lighten-2">
          <v-container>
            <p class="headline">Name</p>
            <p class="content-text">{{ item.name }}</h1>
            <p class="headline">Icon Name</p>
            <p class="content-text"><v-icon>{{ item.icon }}</v-icon></p>
            <p class="headline">Link</p>
            <p class="content-text">{{ item.link }}</p>
            <p class="caption">Modified on: {{ item.modified_on | dateTimeFormat }}</p>
            <p class="caption">Modified by: {{ item.author.email }}</p>
            <v-btn class="primary" @click="showEditForm(item)">Edit Item</v-btn>
            <v-btn dark @click="deleteItem(item, index)">Remove Item</v-btn>
          </v-container>
        </v-card> -->
        <v-data-table
          :headers="headers"
          :items="aboutData"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right"><v-icon>{{props.item.icon }}</v-icon></td>
            <td class="text-xs-right">{{ props.item.link }}</td>
            <td class="text-xs-right"><v-icon v-if="props.item.show" color="green">thumb_up</v-icon><v-icon v-else color="red">thumb_down</v-icon></td>
            <td class="text-xs-right">{{ props.item.modified_on | dateTimeFormat }}</td>
            <td class="text-xs-right">{{ props.item.author.email }}</td>
            <td class="text-xs-right">
              <v-btn
                icon
                class="fa primary small mx-3 white--text"
                color="grey darken-2"
                @click="showEditForm(props.item)"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="fa dark small mx-3 white--text"
                color="grey lighten-1"
                @click="deleteItem(props.item)"
              >
                <v-icon color="black">highlight_off</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex v-if="showAboutForm" xs12 offset-md3 offset-lg2>
        <v-card color="grey lighten-2">
          <v-container>
            <SocialLinksInputForm
              @addItem="addItem"
              @updateItem="editItem"
              @goBack="showAboutForm = !showAboutForm"
              :buttonName="buttonName"
              :editData="editData"
            />
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
// import axios from 'axios'
import Api from '@/api'
import { mapGetters } from 'vuex'
import SocialLinksInputForm from '@/components/SocialLinksInputForm'

export default {
  data () {
    return {
      aboutData: [],
      showAboutForm: false,
      editData: null,
      buttonName: 'Add',
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Icon', align: 'right', value: 'icon' },
        { text: 'Link', align: 'right', value: 'link' },
        { text: 'Show Icon', align: 'right', value: 'show' },
        { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' },
        { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' },
        { text: 'Edit', sortable: false, align: 'right', value: 'edit' }
      ]
    }
  },
  components: {
    SocialLinksInputForm
  },
  beforeMount () {
    if (!this.loginStatus) {
      this.$router.push('/admin/login')
    } else {
      this.getAboutData()
    }
  },
  computed: {
    ...mapGetters({
      loginStatus: 'adminUser/getLoginStatus',
      currentUser: 'adminUser/getLoggedInUser',
      authUsername: 'adminUser/getAuthUser',
      authPassword: 'adminUser/getAuthPassword'
    })
  },
  methods: {
    getAboutData () {
      const path = '/social-links'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            // console.log(response.data.about)
            console.log(response.data.sociallinks)
            this.aboutData = response.data.sociallinks
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    showAddForm () {
      this.showAboutForm = !this.showAboutForm
      this.buttonName = 'Add'
      this.editData = null
    },
    showEditForm (item) {
      this.showAboutForm = !this.showAboutForm
      this.buttonName = 'Update'
      this.editData = item
    },
    addItem (data) {
      const path = '/social-links'
      const auth = {username: this.authUsername, password: this.authPassword}
      let formData = new FormData()
      // formData.append('image', imageFile.files[0])
      formData.append('data', JSON.stringify(data))
      this.$nextTick(() => {
        this.$swal({
          title: 'Adding Item',
          onOpen: () => {
            this.$swal.showLoading()
            Api.post(path, formData, auth)
              .then(response => {
                if (response.data.status === 0) {
                  this.$swal(response.data.message)
                  this.showAboutForm = !this.showAboutForm
                  this.getAboutData()
                } else {
                  this.$swal(response.data.message)
                }
              })
              .catch(error => {
                this.$swal(error.toString().substring(0, 100))
              })
          },
          allowOutsideClick: () => !this.$swal.isLoading()
        })
      })
    },
    editItem (itemId, data) {
      const path = '/social-links/' + itemId
      const auth = {username: this.authUsername, password: this.authPassword}
      let formData = new FormData()
      // formData.append('image', imageFile.files[0])
      formData.append('data', JSON.stringify(data))
      this.$swal({
        title: 'Updating Item',
        onOpen: () => {
          this.$swal.showLoading()
          Api.put(path, formData, auth)
            .then(response => {
              if (response.data.status === 0) {
                this.$swal(response.data.message)
                this.showAboutForm = !this.showAboutForm
                this.getAboutData()
              } else {
                this.$swal(response.data.message)
              }
            })
            .catch(error => {
              this.$swal(error.toString().substring(0, 100))
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      })
    },
    deleteItem (item, index) {
      const path = '/social-links/' + item.id
      const params = {
        current_user: this.currentUser
      }
      const auth = {username: this.authUsername, password: this.authPassword}
      Api.delete(path, params, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.getAboutData()
            this.$swal(response.data.message)
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
#about-page {
  font-family: 'Lato', sans-serif;
  font-size: 1.2vmax;
}
#slogan {
  font-size: 2vmax;
  font-family: 'Vollkorn', serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.page-subheading {
  font-size: 2vmax;
}
</style>


// WEBPACK FOOTER //
// src/admin_pages/SocialLinksMenuItem.vue